module.exports = __webpack_public_path__ + "static/media/rocket.31c7ec72.svg";